import actions from '../../actionTypes';

export default (orgId, loadChildren, loadAreaChildren) => {
  return {
    type: actions.GET_ORG_SITES,
    orgId, 
    loadChildren,
    loadAreaChildren
  };
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/actions/getOrgSites.js